const find = (selector, element = document) => [].slice.call(element.querySelectorAll(selector));

const adjustMaxHeight = element => {
    element.style.maxHeight = `${element.scrollHeight}px`;
};

export const ToggleNavigation = el => {
    const topbar = document.querySelector('.topbar');
    el.addEventListener('click', e => {
        e.preventDefault();
        topbar.classList.toggle('topbar--open');
        document.body.classList.toggle('body--noScroll');
    });
};

export const Navigation = el => {
    let matchesInterestingViewport;

    const onResize = () => {
        matchesInterestingViewport = matchMedia('(max-width: 699px)').matches;
    };
    onResize();

    window.addEventListener('resize', onResize);

    const toggleButtons = find('.navigation__toggleList', el);

    toggleButtons.forEach(button => {
        button.addEventListener('click', () => {
            if (!matchesInterestingViewport) {
                return;
            }

            button.parentNode.classList.toggle('navigation__linkList--open');

            if (button.parentNode.classList.contains('navigation__linkList--open')) {
                adjustMaxHeight(button.parentNode.parentNode);
            } else {
                button.parentNode.parentNode.style.maxHeight = button.previousElementSibling.getBoundingClientRect().height + 'px';
            }
        });
    });

    const setStartingHeight = () => {
        const mainLinks = find('.navigation__linkList > .navigation__link', el);
        mainLinks.forEach(link => {
            link.parentNode.style.maxHeight = link.getBoundingClientRect().height + 'px';
        });
    };

    setTimeout(() => {
        setStartingHeight();
        setTimeout(setStartingHeight, 500);
    }, 0);
};
